import React from 'react';
import PropTypes from 'prop-types';
import { Banner } from '@els/els-react--banner';
import { Button } from '@els/els-react--button';
import store from '@Store';
import Catalyst from '@Services/Catalyst';
import AppStorage from '@Services/AppStorage';
import NavigationHistory from '@Services/NavigationHistory';
import history from '@AppRoutes/history';
import { paths, sourceKeyMapping } from '@AppRoutes/constants';
import { openLoginModal } from '@Pages/Login/LoginActions';
import { trackHistoryBannerInformationCloseButtonClick } from '../../analytics';

const HISTORY_LOGIN_REDIRECT_PATH_STORAGE_KEY = 'historyLoginRedirectPath';

function HistoryBanner({ isVisible, isAnonymous = false, onClose }) {
  if (!isVisible) return null;

  const handleClose = () => {
    trackHistoryBannerInformationCloseButtonClick();
    onClose();
  };

  const onSignin = () => {
    Catalyst.trackConversionDriverClick('history:savesearch:sign-in');
    const currentPath = history.location?.pathname?.includes('saved') ? paths.HISTORY_SAVED : paths.HISTORY_RECENT;
    NavigationHistory.addState(sourceKeyMapping[currentPath], {});
    AppStorage.instance.setToSessionStorage(HISTORY_LOGIN_REDIRECT_PATH_STORAGE_KEY, currentPath);
    store.dispatch(openLoginModal());
  };

  return (
    <Banner type={isAnonymous ? 'alert' : 'info'} isVisible onClose={handleClose} hideCloseLabel icon={isAnonymous ? 'Alert' : 'Clockwise'}>
      {isAnonymous ? (
        <>
          After <strong>one session</strong>, your recent searches will be automatically deleted.{' '}
          <Button type="link" linkOptions={['inline']} onClick={onSignin} data-e2e="history-sign-in-link">
            Sign In
          </Button>{' '}
          to save your history up to six months.
        </>
      ) : (
        <>
          Your recent searches will be automatically deleted after <strong>6 months</strong>. Save your favourite searches if you want to
          keep them for longer. Refined searches or switching between result types are removed <strong>when you leave</strong>, please save
          your search to keep it.
        </>
      )}
    </Banner>
  );
}

HistoryBanner.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isAnonymous: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default HistoryBanner;
